import React, { useState, useEffect } from "react";
import Select from "react-select";
import { IconSend } from "@tabler/icons-react";
import { useUpdateData } from "hooks/useApiHooks";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import { useGuide } from "contexts/v1/masterData/GuideContext";

const UpdateGuide = ({ initialData, refetch, onSuccess, onError, guides }) => {
  const API_URL = "/reservation/change-guide";
  // const { guides } = useGuide();
  // console.log(" guides", guides.data);

  // **Konversi guide ke format select option**
  const guideOptions =
    guides?.data?.map((guide) => ({
      value: guide.id,
      label: guide.name,
    })) || [];

  // **Ambil guide yang sudah dipilih dari initialData**
  const initialSelectedGuides =
    initialData?.guides?.map((guide) => ({
      value: guide.id,
      label: guide.name,
    })) || [];

  // **State untuk menyimpan data guide yang dipilih**
  const [selectedGuides, setSelectedGuides] = useState(initialSelectedGuides);

  const { updateData: updateGuide } = useUpdateData(API_URL);
  const { handleSuccessToast, handleError } = useCanvasHandler();

  // **Handle perubahan pada multi-select**
  const handleGuideChange = (selectedOptions) => {
    setSelectedGuides(selectedOptions || []); // Simpan data baru
  };

  // **Submit data ke API**
  const handleSubmit = async () => {
    if (selectedGuides.length === 0) {
      handleError("Pilih minimal satu guide!");
      return;
    }

    const payload = {
      reservation_ids: [initialData.id], // **Tambahkan reservation_id**
      guide_ids: selectedGuides.map((guide) => guide.value), // **Ambil ID dari guide yang dipilih**
    };

    try {
      await updateGuide(payload);
      // handleSuccessToast("Guides updated successfully");
      if (typeof onSuccess === "function") onSuccess();
      if (typeof refetch === "function") refetch();
    } catch (error) {
      console.error("Error updating guides:", error);
      handleError("Failed to update guides.");
      if (typeof onError === "function") onError();
    }
  };

  // **Update selectedGuides saat `initialData` berubah**
  useEffect(() => {
    if (initialData?.guides) {
      setSelectedGuides(
        initialData.guides.map((guide) => ({
          value: guide.id,
          label: guide.name,
        }))
      );
    }
  }, [initialData]);

  return (
    <form className="d-flex flex-column" style={{ height: "100%" }}>
      <div className="action-sheet-content flex-grow-1">
        <div className="form-group mb-3">
          <label htmlFor="guide" className="form-label">
            Pilih Guide
          </label>
          <Select
            options={guideOptions}
            value={selectedGuides} // **Tampilkan guide yang sudah dipilih**
            onChange={handleGuideChange} // ✅ Multi-select handler
            isMulti={true} // ✅ Aktifkan multi select
            isClearable
            placeholder="Pilih Guide"
            // menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 1050 }) }}
          />

        </div>
      </div>

      {/* 🔥 Tombol Submit */}
      <div className="d-flex justify-content-end mt-0">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSubmit}
        >
          Update Guide <IconSend className="ms-2" size={20} />
        </button>
      </div>
    </form>
  );
};

export default UpdateGuide;
